"use strict";
// Copyright 2019 ProximaX Limited. All rights reserved.
// Use of this source code is governed by the Apache 2.0
// license that can be found in the LICENSE file
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const Http_1 = require("./Http");
const NetworkHttp_1 = require("./NetworkHttp");
const model_1 = require("../model/model");
const MetadataEntry_1 = require("../model/metadata/MetadataEntry");
const metadataRoutesApi_1 = require("./api/metadataRoutesApi");
const MetadataSearch_1 = require("../model/metadata/MetadataSearch");
const Pagination_1 = require("../model/Pagination");
/**
 * Metadata http repository.
 *
 * @since 0.1.0
 */
class MetadataHttp extends Http_1.Http {
    /**
     * Constructor
     * @param url
     * @param networkHttp
     */
    constructor(url, networkHttp) {
        networkHttp = networkHttp == null ? new NetworkHttp_1.NetworkHttp(url) : networkHttp;
        super(networkHttp);
        this.metadataRoutesApi = new metadataRoutesApi_1.MetadataRoutesApi(url);
    }
    /**
     * Get the Metadata for a compositeHash
     * @param compositeHash
     * @returns Observable<MetadataEntry>
     */
    getMetadata(compositeHash, requestOptions) {
        return rxjs_1.from(this.metadataRoutesApi.getMetadata(compositeHash, requestOptions)).pipe(operators_1.map(response => {
            const metadataInlineDTO = response.body;
            return new MetadataEntry_1.MetadataEntry(metadataInlineDTO.metadataEntry.version, metadataInlineDTO.metadataEntry.compositeHash, model_1.Address.createFromEncoded(metadataInlineDTO.metadataEntry.sourceAddress), metadataInlineDTO.metadataEntry.targetKey, new model_1.UInt64(metadataInlineDTO.metadataEntry.scopedMetadataKey), new model_1.UInt64(metadataInlineDTO.metadataEntry.targetId), metadataInlineDTO.metadataEntry.metadataType, metadataInlineDTO.metadataEntry.valueSize, metadataInlineDTO.metadataEntry.value, metadataInlineDTO.id);
        }));
    }
    /**
     * Get the Metadatas for a set of compositeHashes
     * @param compositeHashes
     * @returns Observable<MetadataEntry[]>
     */
    getMetadatas(compositeHashes, requestOptions) {
        let hashes = {
            compositeHashes: compositeHashes
        };
        return rxjs_1.from(this.metadataRoutesApi.getMetadatas(hashes, requestOptions)).pipe(operators_1.map(response => {
            const metadataInlineDTOs = response.body;
            return metadataInlineDTOs.map(metadataDTO => {
                return new MetadataEntry_1.MetadataEntry(metadataDTO.metadataEntry.version, metadataDTO.metadataEntry.compositeHash, model_1.Address.createFromEncoded(metadataDTO.metadataEntry.sourceAddress), metadataDTO.metadataEntry.targetKey, new model_1.UInt64(metadataDTO.metadataEntry.scopedMetadataKey), new model_1.UInt64(metadataDTO.metadataEntry.targetId), metadataDTO.metadataEntry.metadataType, metadataDTO.metadataEntry.valueSize, metadataDTO.metadataEntry.value, metadataDTO.id);
            });
        }));
    }
    /**
     * Get the Metadatas for a set of compositeHashes
     * @param metadataQueryParams
     * @returns Observable<MetadataEntry[]>
     */
    searchMetadata(metadataQueryParams, requestOptions) {
        return rxjs_1.from(this.metadataRoutesApi.searchMetadata(metadataQueryParams, requestOptions)).pipe(operators_1.map(response => {
            let metadataEntries = response.body.data.map(metadataDTO => {
                return new MetadataEntry_1.MetadataEntry(metadataDTO.metadataEntry.version, metadataDTO.metadataEntry.compositeHash, model_1.Address.createFromEncoded(metadataDTO.metadataEntry.sourceAddress), metadataDTO.metadataEntry.targetKey, new model_1.UInt64(metadataDTO.metadataEntry.scopedMetadataKey), new model_1.UInt64(metadataDTO.metadataEntry.targetId), metadataDTO.metadataEntry.metadataType, metadataDTO.metadataEntry.valueSize, metadataDTO.metadataEntry.value, metadataDTO.meta.id);
            });
            let paginationData = new Pagination_1.Pagination(response.body.pagination.totalEntries, response.body.pagination.pageNumber, response.body.pagination.pageSize, response.body.pagination.totalPages);
            return new MetadataSearch_1.MetadataSearch(metadataEntries, paginationData);
        }));
    }
}
exports.MetadataHttp = MetadataHttp;
//# sourceMappingURL=MetadataHttp.js.map